module.exports = __webpack_public_path__ + "static/media/incentive.081162e3.png";